import {
  TrackEventRequest,
  TrackEventParams,
  ApiClient,
} from "@quotientjs/core"

export class Analytics {
  private apiClient: ApiClient

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient
  }

  /**
   * Tracks an analytics event
   * @param options The event data to track
   * @returns A promise that resolves when the track request completes
   */
  async event(options: TrackEventParams): Promise<void> {
    const pathname = options.pathname || window.location.pathname
    const pageUrl = options.pageUrl || window.location.href

    // Create the request with combined options
    const request = new TrackEventRequest({
      pathname,
      pageUrl,
      ...options,
    } as TrackEventParams)

    // Make the API call (the client will handle beacon usage)
    await this.apiClient.call(request)
  }
}
